import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class SettingsEmailsIndexRoute extends Route {
  @service router;

  redirect({ mailerTemplates }) {
    this.router.replaceWith('visitors.settings.emails.templates', mailerTemplates.toArray()[0]?.id);
  }
}
